import Table from './Table'

import './style/css'

export default Table
